import { render } from "./FinancialStatement.vue?vue&type=template&id=a69e2612&scoped=true"
import script from "./FinancialStatement.vue?vue&type=script&lang=js"
export * from "./FinancialStatement.vue?vue&type=script&lang=js"

import "./FinancialStatement.vue?vue&type=style&index=0&id=a69e2612&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a69e2612"]])

export default __exports__